import { KITCHEN_LOCATIONS } from './restaurants.constants';
import { CHICKEN_CHARTS_DASHBOARD, CHICKEN_DASHBOARD, ROLES, POLICIES } from './routes.constants';

export const settingTabs = [
  {
    label: 'Chicken',
    value: 'chicken',
  },
  {
    label: 'Potato',
    value: 'potato',
  },
];

export const eventsTabs = [
  {
    label: 'Chicken',
    value: 'chicken',
    i: '',
  },
  {
    label: 'Potato',
    value: 'potato',
    i: '',
  },
  {
    label: 'Analytics',
    value: 'analytics',
    i: '',
  },
];

export const dashboardTabs = [
  {
    label: 'Summary',
    value: CHICKEN_DASHBOARD,
  },
  {
    label: 'Charts',
    value: CHICKEN_CHARTS_DASHBOARD,
  },
];

export const chickenPotatoDashboardTabs = [
  {
    label: 'Chicken',
    value: 'chicken',
  },
  // {
  //   label: 'Potato',
  //   value: 'potato',
  // },
];

export const unusualTabs = [
  {
    label: 'Unusual Events',
    value: 'event',
  },
  {
    label: 'DP Remaining Potato',
    value: 'dp-remaining',
  },
  {
    label: 'Wrong marker detected',
    value: 'wrong-marker',
  },
  {
    label: 'Empty Pan',
    value: 'empty-pan',
  },
  {
    label: 'Identical Markers',
    value: 'identical-markers',
  },
  {
    label: 'Unusual Recordings',
    value: 'recordings',
  },
];

export const timersCycleTabs = [
  {
    label: 'Breading',
    value: 'breading',
    i: '',
    l: KITCHEN_LOCATIONS.BREADING,
  },
  {
    label: 'Fryer',
    value: 'fryer',
    i: '',
    l: KITCHEN_LOCATIONS.FRYER,
  },
  {
    label: 'Conveyor',
    value: 'conveyor',
    i: '',
    l: KITCHEN_LOCATIONS.CONVEYOR,
  },
  {
    label: 'Hot Holding',
    value: 'hot-holding',
    i: '',
    l: KITCHEN_LOCATIONS.HOT_HOLDING,
  },
  {
    label: 'Merco Hot Holding',
    value: 'merco-hot-holding',
    i: '',
    l: KITCHEN_LOCATIONS.MERCO_HOT_HOLDING,
  },
  {
    label: 'PRS',
    value: 'prs',
    i: '',
    l: KITCHEN_LOCATIONS.PRS,
  },
  {
    label: 'Entree Chutes',
    value: 'entree-chutes',
    i: '',
    l: KITCHEN_LOCATIONS.ENTREE_CHUTES,
  },
  {
    label: 'Sched. Production',
    value: 'scheduled-production',
    i: '',
    l: KITCHEN_LOCATIONS.SCHEDULED_PRODUCTION,
  },
  // TODO: temporary hidden pages (search for 'hidden pages')
  // {
  //   label: 'PRQ',
  //   value: 'prq',
  //   i: '',
  // },
  // {
  //   label: 'Dump Pan',
  //   value: 'dump-pan',
  //   i: '',
  // },
  // {
  //   label: 'Fry Chutes',
  //   value: 'fry-chutes',
  //   i: '',
  // },
  {
    label: 'Analytics',
    value: 'analytics',
    i: '',
  },
];

export const performanceTabs = [
  {
    label: 'Chicken',
    value: 'chicken',
    i: '',
  },
];

export const stockOutTabs = [
  {
    label: 'Chicken',
    value: 'chicken',
    i: '',
  },
];

export const plugTabs = [
  {
    label: 'PnP',
    value: 'plug',
    i: '',
  },
  {
    label: 'Aruco Validation',
    value: 'aruco',
  },
  {
    label: 'Entree Chutes',
    value: 'entree-chutes',
    l: KITCHEN_LOCATIONS.ENTREE_CHUTES,
  },
];

export const monitoringTabs = [
  {
    label: 'Server Management',
    value: 'server-management',
    i: '',
  },
  {
    label: 'Graphics',
    value: 'graphics',
    i: '',
  },
  {
    label: 'PCS Charts',
    value: 'pcs-charts',
    i: '',
  },
  {
    label: 'Alerts',
    value: 'alerts',
    i: '',
  },
];

export const restDevicesTabs = [
  {
    label: 'PC',
    value: 'pc',
    i: '',
  },
  {
    label: 'Tablets',
    value: 'tablets',
    i: '',
  },
];

export const camerasTabs = [
  {
    label: 'View',
    value: 'view',
    i: 'fas fa-eye',
  },
  {
    label: 'Management',
    value: 'settings',
    i: 'fas fa-cog',
  },
  {
    label: 'Media',
    value: 'media',
    i: 'fas fa-film',
  },
];

export const kitchenPlayerTabs = [
  {
    label: 'Player',
    value: 'player',
    i: 'fas fa-eye',
  },
  {
    label: 'Clips',
    value: 'clips',
  },
];

export const pcsTabs = [
  {
    label: 'Monitor',
    value: 'monitor',
    i: '',
  },
  {
    label: 'Scheduled Production',
    value: 'scheduled-production',
    i: '',
  },
  {
    label: 'Recommendations',
    value: 'recommendations',
    i: '',
  },
  {
    label: 'Fryer Manager',
    value: 'fryer-manager',
    i: '',
    l: KITCHEN_LOCATIONS.FRYER,
  },
  {
    label: 'Adjustment',
    value: 'adjustment',
    i: '',
  },
];

export const permissionsTabs = [
  {
    label: 'Roles',
    value: ROLES,
  },
  {
    label: 'Policies',
    value: POLICIES,
  },
];

export const cateringTabs = [
  {
    label: 'Orders',
    value: 'orders',
  },
  {
    label: 'Recurring Orders',
    value: 'recurring-orders',
  },
];
